<template>
  <div
    v-if="suggestions?.length"
    data-testid="suggestions-section"
    class="rounded-lg border border-accent-one-300 bg-accent-one-100 p-4"
  >
    <h4
      class="text-sm font-medium text-accent-one-800 mb-3 flex items-center gap-2"
    >
      <svg
        data-testid="lightbulb-icon"
        class="h-4 w-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
        ></path>
      </svg>
      Suggestions
    </h4>
    <ul class="space-y-2">
      <li
        v-for="suggestion in suggestions"
        :key="suggestion"
        class="text-sm text-accent-one-800 flex items-start gap-2"
      >
        <span class="text-accent-one-500 mt-1.5">💡</span>
        <div class="markdown-content" v-html="renderMarkdown(suggestion)"></div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { renderMarkdown } from '@/utils/markdown';

interface Props {
  suggestions?: string[];
}

defineProps<Props>();
</script>
